// extracted by mini-css-extract-plugin
var _1 = "FloatingToolbar-module__animateUploadProgressBarWidth--hWwJi";
var _2 = "FloatingToolbar-module__animatedBackground--bvWFb";
var _3 = "FloatingToolbar-module__container--hu0d6";
var _4 = "FloatingToolbar-module__hoverWrapper--DWFLi";
var _5 = "FloatingToolbar-module__leftAligned--_NL2S";
var _6 = "20px";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "hoverWrapper", _5 as "leftAligned", _6 as "nearSideHoverTolerance" }
